import axios from 'axios'
import { smavaClientDetails } from 'stores/utils/helpers/clientDetailsData'
import { getEnv } from 'utils/env'

/**
 * Fetches the eKomi HTML snippet from smava endpoint and returns it as raw HTML string.
 * Use inside a component by setting the value via dangerouslySetInnerHTML.
 */
export async function fetchEkomiHtml(): Promise<string> {
  const env = getEnv('REACT_APP_ENV')

  const resolvedUrl = (() => {
    if (!env) return undefined
    const details = smavaClientDetails[env as keyof typeof smavaClientDetails]
    return details?.urls?.ekomiApi
  })()

  if (!resolvedUrl) {
    throw new Error('Ekomi URL not configured for current environment')
  }

  try {
    const res = await axios.get<string>(resolvedUrl, {
      responseType: 'text',
      headers: { Accept: 'text/html, */*' }
    })

    return res.data
  } catch (err: any) {
    const status = err?.response?.status
    const statusText = err?.response?.statusText
    const body: string | undefined = err?.response?.data
    throw new Error(
      `Failed to fetch eKomi component: ${status ?? 'unknown'} ${statusText ?? ''} ${body ? `- ${String(body).slice(0, 200)}` : ''}`
    )
  }
}

/**
 * Convenience helper for React dangerouslySetInnerHTML.
 * <div dangerouslySetInnerHTML={toInnerHtml(html)} />
 */
export function toInnerHtml(html: string): { __html: string } {
  return { __html: html }
}
